import { BASE_URL } from "@/constants/endpoints";
import { EstadosEfectivo } from "@/constants/enums/status/entity-status-ids";
import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let cashRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getCashRequestsApi = async (): Promise<AxiosInstance | null> => {
  if (cashRequestsApiPromise) return cashRequestsApiPromise;
  cashRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return cashRequestsApiPromise;
};

export interface GetCashRequestsProps {
  fechaDesde: string;
  fechaHasta: string;
  monto: string;
  nroCuenta: string;
  idSucursal: number[];
  estados: number[];
  Programadas?: boolean;
  FechaEjecucion?: string;
  "P.Pagina": number;
  "P.Records": number;
}

export const getCashRequests = async (props: GetCashRequestsProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudEfectivo/GetListadoSolicitudes?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetCashRequestProps {
  id: number;
}

export const getCashRequest = async (
  props: GetCashRequestProps,
): Promise<CashRequestDetail | null> => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudEfectivo/GetDetalleSolicitudEfectivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateCashRequestProps {
  idCuentaOrigen: number;
  monto: number;
  claveSucursal: string
  idUsuarioMobile: number;
  mensaje?: string;
}

export const createCashRequest = async (props: CreateCashRequestProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.post(
    `/SolicitudEfectivo/CrearSolicitud?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateScheduledCashRequestProps {
  idCuentaOrigen: number;
  idCuentaDestino?: number;
  idUsuarioMobile?: number;
  monto?: number;
  claveSucursal?: string;
  mensaje?: string;
  fechaEjecucion: string;
}

export const createScheduledCashRequest = async (
  props: CreateScheduledCashRequestProps,
) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.post(
    `/SolicitudEfectivo/CrearSolicitudProgramada?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateCashRequestProps {
  idSolicitud: number;
  estado?: EstadosEfectivo;
  idMotivo?: number;
  monto?: number;
  mensaje?: string;
}

export const updateCashRequest = async (props: UpdateCashRequestProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.put(
    `/SolicitudEfectivo/EditarSolicitudEfectivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
